(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 990;
  var DESKTOP_GAP = 30;
  var MOBILE_GAP = 12;

  /**
   * Returns the number of grid columns to use based on the current viewport
   * and the data-desktop-cols attribute on the grid element.
   */
  function getColCount(grid) {
    var desktopCols = parseInt(grid.dataset.desktopCols) || 4;
    return window.innerWidth < MOBILE_BREAKPOINT ? 2 : desktopCols;
  }

  /**
   * Bin-packing algorithm: assigns explicit grid-row and grid-column to every
   * direct child of the grid so that 2x2 featured tiles and 1x1 product tiles
   * pack tightly with zero whitespace gaps.
   *
   * Works by maintaining a 2D boolean array of occupied cells. For each item
   * (in DOM order), it finds the first top-left slot that fits the item's span,
   * marks those cells occupied, then writes the placement as inline styles.
   */
  function placeGridItems(grid) {
    var cols = getColCount(grid);
    var items = Array.from(grid.children);
    if (!items.length) return;

    // 2D array: occupied[row][col] = true when that cell is taken
    var occupied = [];

    function ensureRows(upToRow) {
      while (occupied.length <= upToRow) {
        occupied.push(new Array(cols).fill(false));
      }
    }

    /**
     * Find the first grid slot (row, col) where an item of size
     * spanCols x spanRows fits. Searches row-by-row, left-to-right.
     */
    function findSlot(spanCols, spanRows) {
      for (var r = 0; ; r++) {
        ensureRows(r + spanRows - 1);
        colLoop: for (var c = 0; c <= cols - spanCols; c++) {
          for (var dr = 0; dr < spanRows; dr++) {
            for (var dc = 0; dc < spanCols; dc++) {
              if (occupied[r + dr][c + dc]) continue colLoop;
            }
          }
          return { row: r, col: c };
        }
      }
    }

    function markOccupied(row, col, spanRows, spanCols) {
      for (var dr = 0; dr < spanRows; dr++) {
        ensureRows(row + dr);
        for (var dc = 0; dc < spanCols; dc++) {
          occupied[row + dr][col + dc] = true;
        }
      }
    }

    items.forEach(function (item) {
      var isFeatured = item.classList.contains('list-products__item--featured');
      var spanC = isFeatured ? 2 : 1;
      var spanR = isFeatured ? 2 : 1;

      // On mobile, a 2-col grid means a 2x2 featured tile fills the full width —
      // that is already correct (2 cols x 2 rows). No adjustment needed.

      var slot = findSlot(spanC, spanR);
      markOccupied(slot.row, slot.col, spanR, spanC);

      // CSS Grid is 1-indexed
      item.style.gridRow = (slot.row + 1) + ' / span ' + spanR;
      item.style.gridColumn = (slot.col + 1) + ' / span ' + spanC;
    });

    // Cap the grid to the actual number of rows used so no trailing empty rows appear
    grid.style.gridTemplateRows = 'repeat(' + occupied.length + ', auto)';
  }

  /**
   * After grid placement, measure the actual rendered height of a 1x1 product
   * tile and set each featured tile's total height to (2 × tileHeight + gap).
   * This ensures the featured media area lines up perfectly with the two
   * adjacent product rows even when product images have varying aspect ratios.
   */
  function syncFeaturedTileHeight(grid) {
    var regularItem = grid.querySelector('.list-products__item:not(.list-products__item--featured)');
    if (!regularItem) return;

    var tileHeight = regularItem.offsetHeight;
    if (!tileHeight) return;

    var gap = window.innerWidth < 750 ? MOBILE_GAP : DESKTOP_GAP;
    var targetHeight = (tileHeight * 2) + gap;

    var featuredItems = grid.querySelectorAll('.list-products__item--featured');
    featuredItems.forEach(function (fi) {
      fi.style.height = targetHeight + 'px';
    });
  }

  /**
   * Clear all inline placement styles so placeGridItems can start fresh
   * on resize (column count may change between desktop and mobile).
   */
  function resetStyles(grid) {
    Array.from(grid.children).forEach(function (item) {
      item.style.gridRow = '';
      item.style.gridColumn = '';
      item.style.height = '';
    });
    grid.style.gridTemplateRows = '';
  }

  function layout(grid) {
    resetStyles(grid);
    placeGridItems(grid);
    // Height sync runs after a short rAF so the browser has applied the
    // explicit grid positions and items have their rendered heights available.
    requestAnimationFrame(function () {
      syncFeaturedTileHeight(grid);
    });
  }

  function init() {
    var grid = document.querySelector('[data-has-featured="true"]');
    if (!grid) return;

    layout(grid);

    // Re-run layout after images (and other assets) load so product tile
    // heights are correct and the featured tile height sync is accurate.
    // Without this, initial load can use wrong heights (tall/short) until resize.
    window.addEventListener('load', function () {
      requestAnimationFrame(function () {
        layout(grid);
      });
    });

    var resizeTimer;
    var lastCols = getColCount(grid);

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newCols = getColCount(grid);
        lastCols = newCols;
        layout(grid);
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
